import { LoadProfileDto, Optimizer } from './pv-calculator.dto';
import { LoadProfileType } from './pv-calculator.dto';

export enum OptimizerMode {
    Auto,
    Manual,
}

export interface PVInputParams {
    optimizer: Optimizer;
    buildingFunctionCode: string;
    fundingRate: number;
    energyPrice: number;
    costModel: string;
    productionOptimizerMode: OptimizerMode;
    targetKwp: number;
    batteryOptimizerMode: OptimizerMode;
    batteryKwpFactor: number;
    loadProfiles: LoadProfileDto[];
    chpProductionProfile: number[] | null;
    constrainFullRoofTo100KWp: boolean;
}

export const DEFAULT_PV_PARAMS: PVInputParams = {
    optimizer: Optimizer.ROI,
    buildingFunctionCode: '',
    fundingRate: 0,
    energyPrice: 0.3,
    costModel: 'ops-2026-04',
    productionOptimizerMode: OptimizerMode.Auto,
    targetKwp: 0,
    batteryOptimizerMode: OptimizerMode.Auto,
    batteryKwpFactor: 1.0,
    loadProfiles: [{ type: LoadProfileType.BASE, annual_usage: null }],
    chpProductionProfile: null,
    constrainFullRoofTo100KWp: false,
};

// Saved variants may still reference the retired pre-release name of the ops model.
const RENAMED_COST_MODELS: Record<string, string> = {
    'ops-2026-04-alpha2': 'ops-2026-04',
};

export function normalizeCostModel(costModel: string | null | undefined): string {
    if (!costModel) {
        // Variants saved before cost models existed were calculated with legacy.
        return 'legacy';
    }
    return RENAMED_COST_MODELS[costModel] ?? costModel;
}

export function getFriendlyOptimizerName(optimizer: Optimizer) {
    switch (optimizer) {
        case Optimizer.ROI:
            return 'Highest return on investment (excess feed-in)';
        case Optimizer.FULL_ROOF:
            return 'Full roof coverage (excess feed-in)';
        case Optimizer.FULL_FEED_IN:
            return 'Full feed-in';
        case Optimizer.RHEINISCHES_REVIER_FUNDING_ROI:
            return 'Rheinisches Revier funding (highest ROI, excess feed-in)';
        case Optimizer.RHEINISCHES_REVIER_FUNDING_MAX_PROD:
            return 'Rheinisches Revier funding (max production, excess feed-in)';
        default:
            throw new Error(`Unknown optimizer: ${optimizer}`);
    }
}
